"use strict";
import Immutable from "immutable";
import CacheBuilder from "./cache_builder";
import Cache from "./cache";
import Mailbox from "./mailbox";
import Effects from "./effects";
import CacheableEffects from "./cacheable_effects";
import UrlUpdate from "./url_update";
import FlashEffect from "./flash_effect";
import ClearCache from "./clear_cache_effect";
Immutable.Iterable.prototype[Symbol.for("get")] = function(value) {
  return this.get(value);
};
export default (function(componentClass, appInit, cacheConfiguration, history) {
  return React.createClass({
    propTypes: {
      children: React.PropTypes.node,
      location: React.PropTypes.object
    },
    statics: {
      maybePresenceService: null,
      registerPresenceService(presenceService) {
        this.maybePresenceService = presenceService;
      },
      maybeDataStoreService: null,
      registerDataStoreService(dataStoreService) {
        this.maybeDataStoreService = dataStoreService;
      }
    },
    ignoreRouteUpdate: false,
    unsubscribeHistory: null,
    getInitialState: function() {
      let route = null;
      this.unsubscribeHistory = history.listen((location) => {
        route = location;
        if (this.state && !this.ignoreRouteUpdate) {
          this.processAction([componentClass.RouteUpdate, route]);
        }
      });
      const { initialCache, getFactory, fetchNeedsConfiguration } = CacheBuilder.build(cacheConfiguration);
      const get = getFactory(initialCache);
      const [component, effects] = appInit(get, route);
      return {
        app: Immutable.Record({
          cache: initialCache,
          getFactory,
          fetchNeedsConfiguration,
          componentClass,
          component,
          initialEffects: effects
        })()
      };
    },
    componentDidMount: function() {
      if (this.constructor.maybeDataStoreService) {
        this.constructor.maybeDataStoreService.setPineApp(this);
      }
      if (this.constructor.maybePresenceService) {
        this.constructor.maybePresenceService.registerStartApp(this);
      }
      this.processEffects(
        this.state.app.component,
        this.state.app.initialEffects,
        this.state.app.cache
      );
    },
    componentWillUnmount: function() {
      this.unsubscribeHistory();
    },
    processAction([action, payload]) {
      const { cache, componentClass: componentClass2, component, getFactory } = this.state.app;
      const get = getFactory(cache);
      this.update(
        componentClass2.update(get, component, [action, payload]),
        cache
      );
    },
    processCacheableAction(originalAddress, data) {
      const { cache, fetchNeedsConfiguration } = this.state.app;
      const updatedCacheData = Cache.updatedCacheData(
        data.get("cacheable") || data.get("graph") || Immutable.Map(),
        fetchNeedsConfiguration,
        cache
      );
      this.cacheUpdated(cache.set("data", updatedCacheData));
      return Mailbox(this.processAction).fromAddress(originalAddress).sendPayload(data);
    },
    cacheUpdated(cache) {
      const { componentClass: componentClass2, component, getFactory } = this.state.app;
      const get = getFactory(cache);
      this.update(
        componentClass2.update(get, component, [this.state.app.get("componentClass").CacheUpdate]),
        cache
      );
    },
    update([component, effects], cache) {
      this.processEffects(component, effects, cache);
    },
    newApp(component, cache) {
      if (cache) {
        return this.state.app.set("component", component).set("cache", cache);
      }
      return this.state.app.set("component", component);
    },
    pushDataUpdate(data) {
      const { cache, fetchNeedsConfiguration } = this.state.app;
      const updatedCacheData = Cache.updatedCacheData(
        data.get("cacheable") || data.get("graph") || Immutable.Map(),
        fetchNeedsConfiguration,
        cache
      );
      const { componentClass: componentClass2, getFactory } = this.state.app;
      getFactory(updatedCacheData);
      this.cacheUpdated(cache.set("data", updatedCacheData));
      this.processAction([componentClass2.PushUpdate, Date.now()]);
    },
    processEffects(component, effects, cache) {
      const { fetchNeedsConfiguration } = this.state.app;
      if (!effects.filter(ClearCache.isClearCache).isEmpty()) {
        const { initialCache } = CacheBuilder.build(cacheConfiguration);
        this.setState({
          app: this.newApp(component, initialCache)
        });
        this.cacheUpdated(initialCache);
      } else {
        const needs = effects.filter(Cache.isNeed);
        const newCache = needs.isEmpty() ? cache : Cache.fetchNeeds(
          this,
          fetchNeedsConfiguration,
          cache,
          needs
        );
        this.setState({
          app: this.newApp(component, newCache)
        });
      }
      const flashMessages = effects.filter(FlashEffect.isFlashMessage);
      flashMessages.forEach(FlashEffect.perform);
      const stealthRouteUpdates = effects.filter(UrlUpdate.isStealthRouteUpdate);
      this.ignoreRouteUpdate = true;
      stealthRouteUpdates.forEach(
        _.partial(UrlUpdate.perform, history)
      );
      this.ignoreRouteUpdate = false;
      const onYourFaceRouteUpdates = effects.filter(UrlUpdate.isOnYourFaceRouteUpdate);
      onYourFaceRouteUpdates.forEach(
        _.partial(UrlUpdate.perform, history)
      );
      const cacheableTasks = effects.filter(CacheableEffects.isCacheableEffect);
      cacheableTasks.forEach(_.partial(
        CacheableEffects.perform,
        this.processCacheableAction
      ));
      const tasks = effects.filter(Effects.isEffect);
      tasks.forEach(_.partial(
        Effects.perform,
        Mailbox(this.processAction)
      ));
    },
    render() {
      return React.createElement(this.state.app.get("componentClass"), {
        model: this.state.app.get("component"),
        mailbox: Mailbox(this.processAction),
        children: this.props.children,
        location: this.props.location
      });
    }
  });
});
